import React from 'react';
import SelectComponent from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { SelectOption } from '@app/types';
import { SelectContainer } from './select-components';
import { Icon } from '@app/components';

type Props = {
  options: SelectOption[];
  value?: SelectOption | SelectOption[];
  onChange?: (e: any) => void;
  placeholder?: string;
  isMulti?: boolean;
  isCustom?: boolean;
  register?: any;
  name?: string;
  disabled?: boolean;
  borderRadius?: number;
};

export default function Select(props: Props) {
  function DropdownIndicator() {
    return <Icon name="arrowDown" />;
  }

  return (
    <SelectContainer borderRadius={props.borderRadius}>
      {props.isCustom ? (
        <CreatableSelect
          className="munitech-select"
          classNamePrefix="munitech"
          components={{ DropdownIndicator }}
          {...props}
        />
      ) : (
        <SelectComponent
          isDisabled={props.disabled}
          className="munitech-select"
          classNamePrefix="munitech"
          components={{ DropdownIndicator }}
          ref={props.register}
          {...props}
        />
      )}
    </SelectContainer>
  );
}
